<script setup>
import { trades } from '@/apis/spotSocket'
import { fix } from '@/utils/math'
import { useSpotStore } from '~/store/spot'

defineProps({
  ob: {
    type: Number,
    default: 0,
  },
})
const loading = ref(true)
const spot = useSpotStore()
spot.getMarketTrades().then(() => {
  loading.value = false
})
const marketTrades = computed(() => {
  if (!spot.marketTrades.length)
    return []
  return trades.value.concat(spot.marketTrades).slice(0, 50)
})
watch(() => spot.code, () => {
  trades.value = []
  spot.marketTrades = []
})
</script>

<template>
  <dl class="relative flex flex-col text-end h-[454px] pb-[18px]">
    <dt class="flex items-start flex-shrink-0 h-[22px] text-textTertiary text-[10px] px-3 ">
      <span class="flex-1 text-start">{{ $t('价格') }}({{ spot.quote }})</span>
      <span class="flex-1 px-1">{{ $t('数量') }}({{ spot.base }})</span>
      <span class="flex-1">{{ $t('成交时间') }}</span>
    </dt>
    <dd class="flex flex-col flex-1 leading-[18px]">
      <n-scrollbar class="!h-[436px] px-3">
        <template v-if="marketTrades.length">
          <div v-for="i in marketTrades" :key="i" class="flex py-px text-[9px] text-textPrimary">
            <span class="flex justify-start flex-1" :class="{ 'text-buy': i.side === 1, 'text-sell': i.side === -1 }">{{ fix(i.price, spot.ps) }}</span>
            <span class="flex-1 px-1">{{ fix(i.volume, spot.as) }}</span>
            <span class="flex-1">{{ i.tm }}</span>
          </div>
        </template>
        <CommonIconsLoading v-else-if="loading" class="w-8 h-8 mx-auto mt-10" />
        <CommonNoData v-else :class="ob ? '!pt-4' : ''" />
      </n-scrollbar>
    </dd>
  </dl>
</template>
